module.exports = __webpack_public_path__ + "static/media/Eventengage_Logo.b7b16b14.png";